const MostPlayedSongSkeleton = () => {
  const arr = [1, 2, 3, 4, 5, 6];

  return (
    <div className="w-full rounded-2xl border border-white/[0.06] bg-white/[0.03] backdrop-blur-sm">
      <div className="p-2">
        <div className="mb-2 flex items-center gap-3 px-4 pt-3">
          <span className="h-6 w-1.5 rounded-full bg-[#1a1919]"></span>
          <div className="h-5 w-32 animate-pulse rounded bg-[#1a1919]"></div>
        </div>

        <div className="px-2">
          {arr.map((item) => (
            <div
              key={item}
              className="flex h-20 items-center gap-3 border-b border-white/[0.05] px-2 last:border-b-0"
            >
              <div className="h-[50px] w-[50px] shrink-0 animate-pulse rounded-lg bg-[#1a1919]"></div>
              <div className="min-w-0 flex-1">
                <div className="h-3 w-3/5 animate-pulse rounded bg-[#1a1919]"></div>
                <div className="mt-2 h-2.5 w-2/5 animate-pulse rounded bg-[#1a1919]"></div>
              </div>
              <div className="h-2.5 w-8 shrink-0 animate-pulse rounded bg-[#1a1919]"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MostPlayedSongSkeleton;
